import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { MdCreateNewFolder } from "react-icons/md";
import { fontstyle1, fontstyle2, fontstyle3 } from "../../utils/fonts";
import generateApiKey from "../../utils/apikey_gen";
import history from "../../utils/history";
import instance from "../../utils/axios";

const NewProject = () => {
  const [nameerror, setNameerror] = useState("");
  const id = useParams().id;

  const generate_key = () => {
    const projectname = document.getElementById("name").value;
    if (projectname === "") {
      setNameerror("Project Name is required");
    } else {
      document.getElementById("api_key").value =
        projectname + "-" + generateApiKey();
      document.getElementById("api_key").readOnly = true;
    }
  };

  const create_project = (e) => {
    e.preventDefault();
    const data = {
      uid: id,
      projectname: e.target.name.value,
      projectdescription: e.target.desc.value,
      apikey: e.target.api_key.value
    };
    instance.post("/newproject", data).then((res) => {
      if (res.data.status === "success") {
        history.back();
      } else {
        console.log("error");
      }
    });
  };

  const verify_projectname = (name) => {
    // check wheather the names has spaces or not
    if (name.indexOf(" ") > -1) {
      setNameerror("Project name cannot have spaces");
    }
    // check wheather the name is empty or not
    else if (name === "") {
      setNameerror("Project name cannot be empty");
    }
    //check wheather the first alphabet is not a special character
    else if (
      name.charAt(0) === "!" ||
      name.charAt(0) === "@" ||
      name.charAt(0) === "#" ||
      name.charAt(0) === "$" ||
      name.charAt(0) === "%" ||
      name.charAt(0) === "^" ||
      name.charAt(0) === "&" ||
      name.charAt(0) === "*" ||
      name.charAt(0) === "(" ||
      name.charAt(0) === ")" ||
      name.charAt(0) === "-" ||
      name.charAt(0) === "_" ||
      name.charAt(0) === "+" ||
      name.charAt(0) === "=" ||
      name.charAt(0) === "{" ||
      name.charAt(0) === "}" ||
      name.charAt(0) === "[" ||
      name.charAt(0) === "]" ||
      name.charAt(0) === "|" ||
      name.charAt(0) === "\\" ||
      name.charAt(0) === ";" ||
      name.charAt(0) === ":" ||
      name.charAt(0) === "'" ||
      name.charAt(0) === '"' ||
      name.charAt(0) === "," ||
      name.charAt(0) === "<" ||
      name.charAt(0) === ">" ||
      name.charAt(0) === "/" ||
      name.charAt(0) === "?" ||
      name.charAt(0) === "." ||
      name.charAt(0) === "`" ||
      name.charAt(0) === "~" ||
      name.charAt(0) === " "
    ) {
      setNameerror("Project name should not start with special character");
    }
    // check wheather the first alphabet is capital or not
    else if (name.charAt(0) === name.charAt(0).toUpperCase()) {
      setNameerror("Project name should not start with capital letter");
    } else {
      setNameerror("");
      document.getElementById("api_key").value = "";
      document.getElementById("api_key").readOnly = false;
    }
  };

  return (
    <div>
      <div className="py-12 bg-[#101426] z-10 ">
        <div className="container mx-auto w-11/12 md:w-2/3 max-w-lg">
          <div
            className="relative py-8 px-5 md:px-10 bg-white shadow-md rounded border border-gray-400"
            style={fontstyle1}
          >
            <div className="w-full flex justify-start text-gray-600 mb-3">
              <MdCreateNewFolder className="text-5xl text-gray-600" />
            </div>
            <form onSubmit={create_project}>
              <h1 className="text-gray-800 font-lg font-bold tracking-normal leading-tight mb-4">
                Add a new project
              </h1>
              <label className="text-gray-800 text-sm font-bold leading-tight tracking-normal">
                Project name
              </label>
              <br />
              <label className="text-gray-400 text-[10px] leading-tight tracking-normal">
                Project name should not have spaces/capital letters/not start
                with a special character
              </label>
              <input
                required
                id="name"
                name="name"
                className="text-gray-600 focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                placeholder="demo"
                style={fontstyle3}
                onChange={(e) => verify_projectname(e.target.value)}
              />
              <div className="text-red-800 mb-3 mt-1 text-[12px]">
                {nameerror}
              </div>

              <label className="text-gray-800 text-sm font-bold leading-tight tracking-normal">
                Project Description
              </label>
              <input
                required
                id="desc"
                name="desc"
                className="mb-5 mt-2 text-gray-600 focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                placeholder="Welcome Project"
                style={fontstyle3}
              />
              <label className="text-gray-800 text-sm font-bold leading-tight tracking-normal">
                API Key{" "}
                <span
                  className="text-blue-800 text-xs cursor-pointer"
                  onClick={generate_key}
                  style={fontstyle2}
                >
                  auto generate
                </span>
              </label>
              <input
                required
                id="api_key"
                name="api_key"
                className="mb-5 mt-2 text-gray-600 focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                placeholder="apikey"
                style={fontstyle3}
              />
              <label className="text-gray-800 text-sm font-bold leading-tight tracking-normal">
                Default Tables{" "}
                <span className="text-xs text-red-800" style={fontstyle1}>
                  * Can't modify
                </span>
              </label>
              <br />
              <label
                className="text-gray-800 text-xs font-bold leading-tight tracking-normal"
                style={fontstyle3}
              >
                Username{" "}
                <span className="text-red-800" style={fontstyle2}>
                  * required
                </span>
              </label>
              <div className="flex gap-0 sm:gap-3 flex-col sm:flex-row">
                <input
                  className="mb-5 mt-2 text-gray-600 focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                  value="Username Type: String"
                />
                <input
                  className="mb-5 mt-2 text-gray-600 focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                  value="Id: dfin_username"
                />
              </div>
              <label
                className="text-gray-800 text-xs font-bold leading-tight tracking-normal"
                style={fontstyle3}
              >
                Email Id{" "}
                <span className="text-red-800" style={fontstyle2}>
                  * required
                </span>
              </label>
              <div className="flex gap-0 sm:gap-3 flex-col sm:flex-row">
                <input
                  className="mb-5 mt-2 text-gray-600 focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                  value="Email Type: String"
                />
                <input
                  className="mb-5 mt-2 text-gray-600 focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                  value="Id: dfin_email"
                />
              </div>
              <label
                className="text-gray-800 text-xs font-bold leading-tight tracking-normal"
                style={fontstyle3}
              >
                Phone Number{" "}
                <span className="text-green-800" style={fontstyle2}>
                  * optional
                </span>
              </label>
              <div className="flex gap-0 sm:gap-3 flex-col sm:flex-row">
                <input
                  className="mb-5 mt-2 text-gray-600 focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                  value="phone Type: String"
                />
                <input
                  className="mb-5 mt-2 text-gray-600 focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                  value="Id: dfin_phone"
                />
              </div>
              <label
                className="text-gray-800 text-xs font-bold leading-tight tracking-normal"
                style={fontstyle3}
              >
                Feedback 1{" "}
                <span className="text-red-800" style={fontstyle2}>
                  * required
                </span>
              </label>
              <div className="flex gap-0 sm:gap-3 flex-col sm:flex-row">
                <input
                  className="mb-5 mt-2 text-gray-600 focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                  value="Feedback 1 Type: String"
                />
                <input
                  className="mb-5 mt-2 text-gray-600 focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                  value="Id: dfin_feed1"
                />
              </div>
              <label
                className="text-gray-800 text-xs font-bold leading-tight tracking-normal"
                style={fontstyle3}
              >
                Feedback 2{" "}
                <span className="text-green-800" style={fontstyle2}>
                  * optional
                </span>
              </label>
              <div className="flex gap-0 sm:gap-3 flex-col sm:flex-row">
                <input
                  className="mb-5 mt-2 text-gray-600 focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                  value="Feedback 2 Type: String"
                />
                <input
                  className="mb-5 mt-2 text-gray-600 focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                  value="Id: dfin_feed2"
                />
              </div>
              <label
                className="text-gray-800 text-xs font-bold leading-tight tracking-normal"
                style={fontstyle3}
              >
                Feedback 3{" "}
                <span className="text-green-800" style={fontstyle2}>
                  * optional
                </span>
              </label>
              <div className="flex gap-0 sm:gap-3 flex-col sm:flex-row">
                <input
                  className="mb-5 mt-2 text-gray-600 focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                  value="Feedback 3 Type: String"
                />
                <input
                  className="mb-5 mt-2 text-gray-600 focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                  value="Id: dfin_feed3"
                />
              </div>

              <div className="flex items-center justify-start w-full">
                <button
                  type="submit"
                  className="focus:outline-none transition duration-150 ease-in-out hover:bg-[#101426] bg-[#101426] rounded text-white px-8 py-2 text-sm"
                >
                  Submit
                </button>
                <div
                  onClick={() => {
                    history.back();
                  }}
                  className="cursor-pointer focus:outline-none ml-3 bg-gray-100 transition duration-150 text-gray-600 ease-in-out hover:border-gray-400 hover:bg-gray-300 border rounded px-8 py-2 text-sm"
                >
                  Cancel
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
export default NewProject;
